import { Pipe, PipeTransform } from '@angular/core';
import { messageStatuses } from 'src/app/enums/messageStatuses';

@Pipe({
  standalone: true,
  name: 'messageStatus'
})
export class MessageStatusFormatPipe implements PipeTransform {
  transform(value: messageStatuses): string {
    let result;
    switch (value) {
      case messageStatuses.NEW:
        result = 'Sent';
        break;
      case messageStatuses.READ:
        result = 'New message';
        break;
      case messageStatuses.REPLIED_STAFF:
        result = 'Responded';
        break;
      case messageStatuses.REPLIED:
        result = 'New';
        break;

      case messageStatuses.CLOSED:
        result = 'Closed';
        break;
      case messageStatuses.DELETED:
        result = 'Deleted';
        break;
      default:
        result = 'No data';
    }
    return result;
  }
}
